<h4 class="page-title">  <i class="fas fa-box-open"></i>
  Produtos do Catálogo {{catalogo ? catalogo.nome : ""}}</h4>

<div class="row">
  <div class="card-box" style="width: 100%;">
    <app-produtos2 [empresa]="{}" [catalogo]="catalogo"></app-produtos2>
  </div>
</div>
